import React, { Component } from 'react';
import { Tabs, Button, message, Select, Tooltip, Icon, Modal, Checkbox } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
//import SearchRetrieve from '../../common/SearchRetrieve.new.js';
const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';
let month = moment().format(monthFormat);

class Filter extends Component {
    handleChange = (params, key) => {
        // if (key === 'begin') {
        //     month = moment(params.begin).format(monthFormat);
        //     params.begin = month;
        //     if(Math.abs(moment(month).diff(moment(params.end),'month')) > 12){
        //         params.end = month;
        //     }
        // } else if (key === 'end') {
        //     month = moment(params.end).format(monthFormat);
        //     params.end = month;
        //     if(Math.abs(moment(month).diff(moment(params.begin),'month')) > 12){
        //         params.begin = month;
        //     }
        // }
        this.props.onChange(params, key);
    }

    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '统计时间段',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class QueryHospital extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const params = this.props.splitParams(searchParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryHospitalUpdateLogMonth,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                type: 'SITE',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        const { begin, end } = searchParams;
        if (begin && end) {
            if (moment(begin).valueOf() > moment(end).valueOf()) {
                return message.warning('开始时间不能大于结束时间')
            }
            if (moment(begin).valueOf() < moment(end).add(-11, 'M').valueOf() ) {
                return message.warning('时间范围不能超过一年')
            }
        }
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const columns = [{
            title: '统计月份',
            dataIndex: 'yearMonthNumStr',
            key: 'yearMonthNumStr',
            fixed: 'left',
            width: 80,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            fixed: 'left',
            width: 160,
        }, {
            title: '等级',
            dataIndex: 'hospitalLevel',
            key: 'hospitalLevel',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '详细地址',
            dataIndex: 'hospitalAddress',
            key: 'hospitalAddress',
            width: 180,
        }, {
            title: '与津石是否有合作',
            dataIndex: 'systemCooperation',
            key: 'systemCooperation',
            width: 80,
            render: text => {
                return text?'是':'否'
            }
        },{
            title: '状态',
            dataIndex: 'typeShow',
            key: 'typeShow',
            width: 80,
        }, {
            title: '变更前医院名称',
            dataIndex: 'beforeValue',
            key: 'beforeValue',
            width: 160,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byCrc"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class QueryDepartment extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const params = this.props.splitParams(searchParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryDepartmentUpdateLogMonth,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                type: 'INV',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { searchParams:{ date } } = this.state;
        const columns = [{
            title: '统计月份',
            dataIndex: 'yearMonthNumStr',
            key: 'yearMonthNumStr',
            fixed: 'left',
            width: 80,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            fixed: 'left',
            width: 160,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'typeShow',
            key: 'typeShow',
            width: 80,
        }, {
            title: '变更前科室名称',
            dataIndex: 'beforeValue',
            key: 'beforeValue',
            width: 160,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byDepartment"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class HosAndDepChange extends Component {
    state = {
        panes: [{
            title: '医院变更记录',
            key: 'queryHospital',
            content: null,
        }, {
            title: '医院科室变更记录',
            key: 'queryDepartment',
            content: null,
        }],
        activeKey: 'queryHospital',
        searchParams: {},
        visible:false,
        exportHospital:false,
        exportDepartment:false,
    }

    componentDidMount() {
        this.updatePanes();
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { trueMonth, trueYear } = res;
            const { searchParams } = this.state;
            searchParams.begin = `${trueYear}-${trueMonth}`;
            searchParams.end = `${trueYear}-${trueMonth}`;
            this.setState({
                searchParams,
                curParams: {...searchParams},
            }, () => {
                this.search();
            });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        searchParams.begin &&
        this.setState({
            searchParams: {...searchParams}
        }, () => {
            const { searchParams } = this.state;
            this.childRef.search(searchParams);
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    export = (type) => {
        const { activeKey, sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportHospitalUpdateLogMonth,
            data: {
                ...sortParams,
                ...params,
                offset: 1,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    updatePanes = () => {
        const { panes, activeKey, searchParams } = this.state;
        let RenderContent = null;
        if (activeKey == 'queryHospital') {
            RenderContent = QueryHospital;
        } else if (activeKey == 'queryDepartment') {
            RenderContent = QueryDepartment;
        } 
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent ref={el => this.childRef = el} searchParams={searchParams} splitParams={this.splitParams}/>;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes },() => this.search());
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    onOk = () =>{
        const {exportHospital, exportDepartment} = this.state;
        if(exportHospital || exportDepartment){
            exportHospital &&this.export('hospital');
            exportDepartment && this.export('department');
            this.onCancel();
        }else{
            message.error('请选择导出内容')
        }
        
    }

    onCancel = () =>{
        this.setState({
            visible:false,
            exportHospital:false,
            exportDepartment:false,
        })
    }

    render() {
        const { exportable } = this.props;
        const { panes, activeKey, businessList, searchParams, visible, exportHospital,exportDepartment } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <div style={{marginTop: 20, marginBottom: 4, float:'fixed'}}>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    businessList={businessList}
                    buttons={[
                            <Button key="export" type="primary" onClick={()=>{this.setState({visible:true})}} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                </div>
                
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key} >{pane.content}</TabPane>)}
                </Tabs>
                <Modal
                title='导出'
                visible={visible}
                className="creat-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="350px"
                onOk={this.onOk}
                onCancel={this.onCancel}
            >
                <div style={{padding:'0 20px'}}>
                    <div style={{marginBottom:'10px'}}>请选择导出内容:</div>
                    <Checkbox checked={exportHospital} onChange={(e) => {this.setState({exportHospital:!exportHospital})}} style={{marginBottom:'10px'}}>医院变更记录</Checkbox>
                    <br />
                    <Checkbox checked={exportDepartment} onChange={(e) => {this.setState({exportDepartment:!exportDepartment})}}>医院科室变更记录</Checkbox>
                </div>
            </Modal>
            </div>
        );
    }
}

export default HosAndDepChange;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/hosAndDepChange.js